<template>
  <div id="app">
    <router-view v-slot="{ Component, route }">
      <transition name="fade" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
    <!-- GlobalAudio placeholder, implemented in M6 -->
    <GlobalAudio />
  </div>
</template>

<script>
import GlobalAudio from '@/components/GlobalAudio.vue'

export default {
  components: { GlobalAudio },
}
</script>

<style lang="less">
@import '@/assets/less/index.less';

#app {
  min-height: 100vh;
}
</style>